export default landscapeCtrl

/** @ngInject */
function landscapeCtrl($scope, $rootScope, $q, $uibModal, $state, $stateParams, $window, User, ApiService, AlertManager, PotManager, ContractService,
ContractDraft, gaEventsService, ErrorCatcher, LandscapeQuestions) {
    $scope.idContract = $stateParams.id
    $scope.contract = { id: $scope.idContract, isDraft: true }
    return LandscapeQuestions.search({
        category: 'c-est-parti',
        id_contract: $stateParams.id,
        draft: true,
    }).$promise
    .then((landscapeQuestions) => {
        let isNew = false
        if (landscapeQuestions && (landscapeQuestions.length === 1)) {
            if ((landscapeQuestions[0][0].answer === undefined) || (landscapeQuestions[0][0].answer === '') || (landscapeQuestions[0][0].answer === false)) {
                isNew = true
            }
        }
        const edit = $stateParams.edit
        $scope.landscapeQuestions = landscapeQuestions

        $scope.isEdition = { edition: edit, new: isNew }
        $scope.isEdition = edit
        $scope.isNew = isNew
        if (landscapeQuestions[0][0] && (edit !== true)) {
            const lastBlock = landscapeQuestions[landscapeQuestions.length - 1]
            if (lastBlock[Object.keys(lastBlock).length - 1] && lastBlock[Object.keys(lastBlock).length - 1].last) {
                window.dispatchEvent('landscapeDone')
                $scope.landscapeDone = true
            }
        }
    })
}



// WEBPACK FOOTER //
// ./src/states/landscape/landscape.js